import { Route, Routes } from "react-router-dom";

import { Shell } from "./components/Shell";
import { Applications } from "./sections/Applications";
import { Colour } from "./sections/Colour";
import { Cover } from "./sections/Cover";
import { Foundation } from "./sections/Foundation";
import { Imagery } from "./sections/Imagery";
import { Logo } from "./sections/Logo";
import { MotifsAndMotion } from "./sections/MotifsAndMotion";
import { Typography } from "./sections/Typography";
import { UseCases } from "./sections/UseCases";
import { Voice } from "./sections/Voice";

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Cover />} />
        <Route path="/foundation" element={<Foundation />} />
        <Route path="/voice" element={<Voice />} />
        <Route path="/logo" element={<Logo />} />
        <Route path="/typography" element={<Typography />} />
        <Route path="/colour" element={<Colour />} />
        <Route path="/imagery" element={<Imagery />} />
        <Route path="/motifs" element={<MotifsAndMotion />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/use-cases" element={<UseCases />} />
      </Routes>
    </Shell>
  );
}
